import axios from 'axios'

const API_PATH = 'api/v2/admins/bnk_warehouse_locations'

const BnkWarehouseLocationApiV2 = {
  /**
   * Get list of `District`
   * @param {string} location - location name
   * @param {number} sublocation - sublocation name
   * @return {object} Collection of `Bnk Warehouse Locations`
   */
  get: async (location, params = {}) => {
    const path = API_PATH

    const response = axios.get(path, {
      params: {
        location: location,
        ...params
      }
    })
    return response
  },

  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  create: async ({ name, type_name, active = true }) => {
    const payload = {
      name,
      type_name,
      active
    }

    const response = axios.post(API_PATH, payload)
    return response
  },

  update: async ({ id, name, type_name, active }) => {
    const path = `${API_PATH}/${id}`
    const payload = {
      name,
      type_name,
      active
    }

    const response = axios.patch(path, payload)
    return response
  }
}

export default BnkWarehouseLocationApiV2
